module.exports = __webpack_public_path__ + "static/media/S-WEB-Goal-13.4fde52d6.png";